import * as React from "react";

import { useProvidedState } from "@shared-ui/provided-state-context";

import { ExtendedFTNode } from "typings/flexFramework/FlexComponent";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

import { ClientWizardStateStore } from "stores/wizard/ClientWizardStateStore";
import { WizardWithHeroImage } from "./components/WizardWithHeroImage";
import { WizardForTripsHero } from "./components/WizardForHeroTrips";
import { isVariantEnabled, Experiment } from "src/components/utility/experiment";

export interface WizardHeroProps {
  wizardLOBs: ExtendedFTNode[];
  wizardFormChildren: React.ReactElement[];
  trackOnChangeTab: (tabName: string, rfrrId?: string) => void;
  context: ExtendedContextStore;
  heroImageFigureClassNames: string;
  heroImageSrc: string;
  heroImageColor?: string;
  wizardState: ClientWizardStateStore;
  aboveOtherFormChildren?: React.ReactElement[];
  belowOtherFormChildren?: React.ReactElement[];
}

export const WizardHero: React.FC<WizardHeroProps> = (props) => {
  const { Trip_Hero_Web, EXPEDIA_BRAND_REFRESH_JUNE } = Experiment;
  const { context } = props;
  const [data] = useProvidedState();
  const [isLoaded, setIsLoaded] = React.useState(false);
  const isTripsHeroBucketed = isVariantEnabled(context, Trip_Hero_Web, 1);
  const isBrandRefreshJuneEnabled = isVariantEnabled(context, EXPEDIA_BRAND_REFRESH_JUNE, 1);

  React.useEffect(() => {
    setIsLoaded(true);
  }, []);

  const shouldSSRTripsHeroWizard = isTripsHeroBucketed && !isBrandRefreshJuneEnabled && !isLoaded;
  const shouldCSRTripsHeroWizard = data?.tripsHero?.isRendered && isLoaded;

  if (shouldSSRTripsHeroWizard || shouldCSRTripsHeroWizard) {
    return <WizardForTripsHero {...props} />;
  }

  return <WizardWithHeroImage {...props} />;
};
